import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";
import { calculateOwnership } from "../genericCalculations/ownership";
import {
  calculateRealestateTotalSellingCosts,
  calculateRealestateTotalSellingCostsBase,
} from "./totalSellingCosts";

const ownedSellingCosts = (
  totalSellingCosts: number,
  ownership: number
) => calculateOwnership(Number(totalSellingCosts), ownership);

export const calculateRealestateNetBalance = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const balance = calculateRealestateBalanceBase(userProduct, {
    baseCurrency,
    currentCurrency,
  });
  const totalSellingCosts = calculateRealestateTotalSellingCostsBase(
    userProduct,
    baseCurrency,
    currentCurrency
  );

  return (
    Number(balance) -
    ownedSellingCosts(Number(totalSellingCosts), userProduct?.ownership || 0)
  );
};

export const calculateRealestateNetBalanceBase = (
  userProduct: RealestateAsset,
  currencies: { baseCurrency: Fiat; currentCurrency: Fiat }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  return calculateRealestateNetBalance(
    userProduct,
    baseCurrency,
    currentCurrency
  );
};

export const calculateRealestateBalanceBase = (
  userProduct: RealestateAsset,
  currencies: { baseCurrency: Fiat; currentCurrency: Fiat }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  const balance = userProduct?.value || 0;
  const ownership = userProduct?.ownership || 0;

  const balanceBase = convertCurrency(balance, baseCurrency, currentCurrency);

  return calculateOwnership(balanceBase, ownership);
};

export const realestateBalance = (userProduct: RealestateAsset) => {
  const balance = userProduct?.value || 0;
  const ownership = userProduct?.ownership || 0;

  return calculateOwnership(balance, ownership);
};

export const realestateNetBalance = (userProduct: RealestateAsset) => {
  const balance = realestateBalance(userProduct);
  const totalSellingCosts = calculateRealestateTotalSellingCosts(userProduct);

  return (
    Number(balance) -
    ownedSellingCosts(Number(totalSellingCosts), userProduct?.ownership || 0)
  );
};
